module.exports = __webpack_public_path__ + "img/yat-siu.f52279c9.png";